"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* -- Generated File: Do Not Edit ------------------------------------------ */
/* -- Generated from ./scripts/generate.ts -- */
var react_1 = __importDefault(require("react"));
var icon_1 = require("./icon");
exports.IconPlay = react_1.default.forwardRef(function (props, ref) {
    return ((0, jsx_runtime_1.jsx)(icon_1.Icon, __assign({ ref: ref }, props, { children: function (_a) {
            var className = _a.className, size = _a.size, restProps = __rest(_a, ["className", "size"]);
            if (size === 'small') {
                return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: className, "data-name": "IconPlay", fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3.5 2.16069C3.5 1.64616 4.05814 1.32558 4.50258 1.58484L14.5128 7.42415C14.9538 7.6814 14.9538 8.3186 14.5128 8.57585L4.50258 14.4152C4.05814 14.6744 3.5 14.3538 3.5 13.8393V2.16069Z", fill: "currentColor" }) })));
            }
            if (size === 'large') {
                return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: className, "data-name": "IconPlay", fill: "none", height: "36", viewBox: "0 0 36 36", width: "36", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: (0, jsx_runtime_1.jsx)("path", { d: "M6 4.53691C6 3.396 7.2232 2.67276 8.22288 3.22258L33.6103 17.1857C34.6465 17.7556 34.6465 19.2444 33.6103 19.8143L8.22288 33.7774C7.2232 34.3272 6 33.604 6 32.4631V4.53691Z", fill: "currentColor" }) })));
            }
            if (size === 'jumbo') {
                return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: className, "data-name": "IconPlay", fill: "none", height: "48", viewBox: "0 0 48 48", width: "48", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 5.38254C9 3.86133 10.6309 2.89701 11.9638 3.63011L45.8138 22.2476C47.1953 23.0074 47.1953 24.9926 45.8138 25.7524L11.9638 44.3699C10.6309 45.103 9 44.1387 9 42.6175V5.38254Z", fill: "currentColor" }) })));
            }
            return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: className, "data-name": "IconPlay", fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: (0, jsx_runtime_1.jsx)("path", { d: "M5 2.69127C5 1.93067 5.81547 1.44851 6.48192 1.81506L23.4069 11.1238C24.0977 11.5037 24.0977 12.4963 23.4069 12.8762L6.48192 22.1849C5.81546 22.5515 5 22.0693 5 21.3087V2.69127Z", fill: "currentColor" }) })));
        } })));
});
exports.default = exports.IconPlay;
exports.IconPlay.displayName = 'IconPlay';
exports.IconPlay.metadata = 'video, music, sound, media-player-controls';
//# sourceMappingURL=iconPlay.js.map